<template>
  <div class="login-page">
    <div class="login-box">
      <div class="login-title">
        <h2>刷题系统管理后台</h2>
        <p>请使用管理员账号登录</p>
      </div>
      <el-form :model="form" :rules="rules" ref="loginForm" @submit.native.prevent="handleLogin">
        <el-form-item prop="username">
          <el-input
            v-model="form.username"
            prefix-icon="el-icon-user"
            placeholder="请输入用户名"
            size="large"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            type="password"
            prefix-icon="el-icon-lock"
            placeholder="请输入密码"
            show-password
            size="large"
          />
        </el-form-item>
        <el-button
          type="primary"
          native-type="submit"
          :loading="loading"
          class="login-btn"
          size="large"
        >
          {{ loading ? '登录中...' : '立即登录' }}
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import request from '../utils/request'

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  created() {
    const token = localStorage.getItem('admin_token')
    if (!token) return
    let role = 'ADMIN'
    try {
      role = JSON.parse(localStorage.getItem('admin_info') || '{}').role || 'ADMIN'
    } catch (e) {
      role = 'ADMIN'
    }
    this.$router.replace(role === 'TEACHER' ? '/teacher/classes' : '/')
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (!valid) return
        this.loading = true
        request.post('/auth/login', this.form).then(data => {
          localStorage.setItem('admin_token', data.token)
          localStorage.setItem('admin_info', JSON.stringify({
            id: data.adminId,
            username: data.username,
            role: data.role,
            subjectId: data.subjectId
          }))
          this.$message.success('登录成功')
          if (data.role === 'TEACHER') {
            this.$router.replace('/teacher/classes')
          } else {
            this.$router.replace('/')
          }
        }).catch(() => {}).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #1677ff 0%, #003a8c 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-box {
  background: #fff;
  border-radius: 12px;
  padding: 48px 40px;
  width: 400px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
}
.login-title {
  text-align: center;
  margin-bottom: 36px;
}
.login-title h2 {
  font-size: 22px;
  color: #333;
  margin-bottom: 8px;
}
.login-title p {
  color: #999;
  font-size: 14px;
}
.login-btn {
  width: 100%;
  margin-top: 8px;
}
</style>
